import cx from 'classnames';
import { h } from 'preact';
import { apnumber } from 'journalize';

function OtherCandidate({ isViewable, candidateCount, onClick }) {
  const classes = cx('candidate race__candidate-row', {
    'race__candidate-row--hidden': !isViewable,
  });

  return (
    <tr class={classes}>
      <td
        class="candidate__cell candidate__party t-align-center"
        onClick={onClick}
      >
        <svg class="icon icon-angle-down">
          <use xlinkHref="#icon-angle-down" />
        </svg>
      </td>
      <th class="candidate__cell candidate__name">
        <button onClick={onClick}>Show {apnumber(candidateCount)} more </button>
      </th>
    </tr>
  );
}

export default OtherCandidate;
